import React, { useState,useEffect, useMemo} from 'react';
import { DataTable } from '../details/DataTable';
import { Modal, Form, Button, CloseButton } from '@deere/ux.uxframe-react';
import { useTranslation } from "react-i18next"; 
import { useOktaAuth } from '@okta/okta-react';
import { ReactComponent as ExcelIcon } from "@deere/ux.brand-foundations/icons/excel.svg";
import { excelPartsExport } from '../../utils/downloadUtils';
import { SVGIconDelete } from '../SVGIcon'; 
import { useUserInfo } from '../../providers/userProvider';
import { CM_RESPONSE_STATUS, CRS_SURVEY_CODES, SCBM_STATES_CAMPAIGN, PART_POPUP_HEADER, PART_POPUP_ACCESSOR_KEYS, CRS_SURVEY_TEMPLATES, EWDC, PART_FIRST_NAME_COLUMN, PART_RACF_COLUMN, addCol1Accessor, addCol2Accessor, addCol1 } from '../../utils/surveyLiterals';
import {isUserAnAdminOfSurvey} from '../../utils/utils';
import { ModalGeneric } from '../ModalGeneric';


export const PartPopUp = ({ show, handleClose, requestNumber,  campaign, partFunc, partDeleteFunc , showDeletButton, survey, additionalColumns, isAuthMethodOkta, token }) => {
    const userInfo = useUserInfo();
    const { authState } = useOktaAuth();
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [downloading, setDownloading] = useState(false);
    const [partId, setPartId] = useState();
    const [showModal, setShowModal] = useState(false);
    const [partsDelete,setPartsDeleted]= useState(false);
    const additionalCols = additionalColumns ? additionalColumns.filter((ac) => ac.isNonDeere === campaign.isNonDeere && ac.defaultColumnMapping && ac.defaultColumnMapping !== "") : [];
    const accessToken = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? token : authState.accessToken.accessToken;
    const columns = useMemo(
        () => {
                return [
                    {
                        Header: campaign.surveyCode === EWDC ? PART_FIRST_NAME_COLUMN : campaign.isNonDeere? PART_POPUP_HEADER.PART : PART_POPUP_HEADER.DEEREPART,
                        accessor: campaign.isNonDeere ? PART_POPUP_ACCESSOR_KEYS.PART : PART_POPUP_ACCESSOR_KEYS.DEEREPART,
                        id:'deerePartShow'
                    },
                    
                    {
                        Header: PART_POPUP_HEADER.DECLARED,
                        accessor: PART_POPUP_ACCESSOR_KEYS.DECLARED
                    }
                ]
          
        },
        [data]
    )

      let surveyCode = campaign && campaign.surveyCode ? campaign.surveyCode : survey && survey.code ? survey.code : "";
      let templateType = campaign && campaign.templateType ? campaign.templateType : survey && survey.templateType ? survey.templateType : "";
      if (campaign.surveyCode === EWDC) {
        columns.push({
            Header: PART_RACF_COLUMN ,
            accessor: PART_POPUP_ACCESSOR_KEYS.HSCODE
        });
      } else if (( surveyCode === CRS_SURVEY_CODES.TPS) || (surveyCode === CRS_SURVEY_CODES.TPSMEX)  || (templateType === CRS_SURVEY_TEMPLATES.PART)){
        additionalCols.forEach((dc) => {
            if (dc.defaultColumnMapping === addCol1)
              columns.push({ Header: dc.columnNames, accessor: addCol1Accessor });
            else 
              columns.push({ Header: dc.columnNames, accessor: addCol2Accessor });
          });
      }

      if (showDeletButton && isUserAnAdminOfSurvey(userInfo.roles, campaign.adminRole)  && campaign.status !== SCBM_STATES_CAMPAIGN.CLOSED ) {         
        columns.push({
            Header: 'Delete',
            accessor: 'deerePartNumber',
            id:'deerePartDelete',
            Cell: cell => iconDelete(cell)
        });
    }
    const handleExcelDownload = e => {
        try {
            setDownloading(true)
            excelPartsExport(data,columns,requestNumber,[{Header: 'Delete'}, {Header:'Deere Part Description'}], surveyCode, campaign.isNonDeere, campaign.templateType, additionalCols);
            setDownloading(false)
        }
        catch (err) {
            setDownloading(false)
            throw err
        }
    }
    const iconDelete = (cell) => {
        return <div align="center">
            <a href='#' onClick={e => {
                e.preventDefault();
                handledDelete(cell);
            }}>
                <SVGIconDelete />
            </a>
        </div>
    };
    
    const handledDelete = (cell) => {
        let rowNumber = cell.cell.row.id;
        let id=cell.data[rowNumber].id;
        setPartId(id);         
        setShowModal(true);
    };
    const handleSubmit = async () => { 
       setShowModal(false);
        try{

           const res =await partDeleteFunc(requestNumber, campaign.surveyCode, partId, authState.accessToken.accessToken, campaign.templateType);
                if(res>0){
                    loadData()  
                    setPartsDeleted(true)
                } 
        }
        catch(er){
            console.log("HandleDeletePart Error ")
            console.log(er) 
         throw er
        }
    }

    const handleClosePopUp=()=>{
        handleClose(partsDelete)
    }

    const loadData= ()=>{
        partFunc(requestNumber, accessToken, campaign.surveyCode, campaign.isNonDeere, campaign.templateType, isAuthMethodOkta).then(response =>{
                if(response && Array.isArray(response)){                    
                    response.forEach(part =>{
                        part.declared = part.statusResponse === CM_RESPONSE_STATUS.SUBMITTED ?'Yes':'No'
                          
                    })
                    setData([...response]);
                } else{
                    console.log("No parts availble");
                    setData([]);
                } 
            }).catch(error => {
                console.log(error);
            })
    }

    useEffect(() => {
        if (!data || data.length <= 0) {
            loadData()
        }
    }, [accessToken, data.length]);

    return (
        <Modal  size='lg' show ={show}>
                <Modal.Header>
                    <Modal.Title>{campaign.surveyCode === EWDC ? "Employee Count" : "Part Count"}</Modal.Title>
                    <CloseButton onClick={handleClosePopUp}/>
                </Modal.Header>
                <Modal.Body scrollable='true' style={{height: '350px',overflowY: "auto"}}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 'bold' }}>
                            Request Number {requestNumber}
                        </Form.Label>
                    </Form.Group>
                    <Form.Group>
                      <DataTable data={data} columns={columns} />
                    </Form.Group>
                     <ModalGeneric showModal={showModal}
                            setShowModal={setShowModal}
                            labelBtnPrimary={t('t2_remove')}
                            labelBtnSecondary={t('btn_cancel')}
                            handleSubmit={handleSubmit}
                            msgModal={t('modal_generic_msg')}
                            titleModal={t('t2_remove')}
                        />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClosePopUp} variant="secondary">Close</Button>
                    {
                        downloading || !data || data.length <1?null:<Button variant="outline-success" onClick={handleExcelDownload}> <ExcelIcon size='sm' /> {'Download'} </Button>
                    }
                </Modal.Footer>
            </Modal>
           
    )
}